// src/ui/theme/index.js

import { createTheme } from '@material-ui/core/styles';

const palette = { primary: { main: '#af1f22' } };
const themeName = 'Atrias';

export default createTheme({ palette, themeName });
